import { ADD_ALL_DIAGNOSIS, ADD_FEEDBACK, ADD_MEDICINE, DELETE_ALL_DIAGNOSIS, DELETE_FEEDBACK, DELETE_MEDICINE, GET_ALL_DIAGNOSIS, GET_ALL_FEEDBACK, GET_ALL_MEDICINE, SEARCH_ALL_DIAGNOSIS, SEARCH_MEDICINE, SHOW_ALL_DIAGNOSIS, UPDATE_ALL_DIAGNOSIS, UPDATE_FEEDBACK, UPDATE_MEDICINE, VIEW_FEEDBACK, VIEW_FEEDBACK_BY_ID, VIEW_MEDICINE } from "../actions/Feedback.action";

const initialState = {
    addFeedback: '',
    viewFeedbackById: '',
    deleteFeedback: '',
    updateFeedback: '',
    viewFeedback: '',
    getAllFeedback: '',
    getAllDiagnosis: '',
    addAllDiagnosis: '',
    showAllDiagnosis: '',
    updateAllDiagnosis: '',
    getAllMedicine: '',
    addMedicine: '',
    viewMedicine: '',
    deleteMedicine: '',
    updateMedicine: '',
}

const feedbackReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_FEEDBACK:
            return { ...state, addFeedback: action.payload };
        case VIEW_FEEDBACK_BY_ID:
            return { ...state, viewFeedbackById: action.payload };
        case DELETE_FEEDBACK:
            return { ...state, deleteFeedback: action.payload };
        case UPDATE_FEEDBACK:
            return { ...state, updateFeedback: action.payload };
        case VIEW_FEEDBACK:
            return { ...state, viewFeedback: action.payload };
        case GET_ALL_FEEDBACK:
            return { ...state, getAllFeedback: action.payload };
        case GET_ALL_DIAGNOSIS:
            return { ...state, getAllDiagnosis: action.payload };
        case SEARCH_ALL_DIAGNOSIS:
            return { ...state, getAllDiagnosis: action.payload };
        case ADD_ALL_DIAGNOSIS:
            return { ...state, addAllDiagnosis: action.payload };
        case SHOW_ALL_DIAGNOSIS:
            return { ...state, showAllDiagnosis: action.payload };
        case UPDATE_ALL_DIAGNOSIS:
            return { ...state, showAllDiagnosis: action.payload };
        case GET_ALL_MEDICINE:
            return { ...state, getAllMedicine: action.payload };
        case SEARCH_MEDICINE:
            return { ...state, getAllMedicine: action.payload };
        case ADD_MEDICINE:
            return { ...state, addMedicine: action.payload };
        case VIEW_MEDICINE:
            return { ...state, viewMedicine: action.payload };
        case DELETE_MEDICINE:
            return { ...state, deleteMedicine: action.payload };
        case UPDATE_MEDICINE:
            return { ...state, updateMedicine: action.payload };
        case DELETE_ALL_DIAGNOSIS:
            return { ...state, deleteAllDiagnosis: action.payload };
        default:
            return state;
    }
}

export default feedbackReducer;